export default __webpack_public_path__ + "static/media/nick-fewings-f2Bi-VBs71M-unsplash.eca1d594.jpg";